export default __webpack_public_path__ + "static/mean-cycle-2-m-ab922d78e6787d45b3e22f1ae3f9968a.svg";